import { AxiosError } from 'axios'
import { type QueryObserverOptions, useQuery } from 'react-query'

import useAuth from 'hooks/use-auth'
import { apiKeysQueryKeys } from 'queries/apikeys/query-keys'
import { fetchApiKeysAllForCompany } from 'queries/apikeys/query-utils'

import type { ApiKey } from 'types/api/api-key'

export function useGetApiKeysAllForCompany(
  options: QueryObserverOptions<ApiKey[], AxiosError> = {}
) {
  const { currentTeamId } = useAuth()

  return useQuery<ApiKey[]>({
    ...options,
    queryKey: apiKeysQueryKeys.getAllForCompany({ teamId: currentTeamId }),
    queryFn: fetchApiKeysAllForCompany
  })
}
